import React, { useEffect, useState } from 'react';
import './TaskForm.css';

function TaskForm({
  onSubmit,
  onClose,
  parentTask,
  isSubtask,
  users = [],
  projects = [],
  showProjectSelector = false
}) {
  const [formData, setFormData] = useState({
    title: '',
    status: '',
    responsible: '',
    validator: '',
    dueDate: '',
    notes: '',
    project: '',
    parentTask: isSubtask ? parentTask : null
  });

  useEffect(() => {
    if (isSubtask) {
      setFormData((prev) => ({ ...prev, parentTask }));
    }
  }, [parentTask, isSubtask]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  const safeUsers = Array.isArray(users) ? users : [];
  const safeProjects = Array.isArray(projects) ? projects : [];

  return (
    <div className="modal-overlay">
      <div className="modal-content form-container">
        <h2>{isSubtask ? 'Agregar Subtarea' : 'Crear Nueva Tarea'}</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group full-width">
            <input
              type="text"
              name="title"
              placeholder="Título"
              value={formData.title}
              onChange={handleChange}
              required
            />
          </div>

          {showProjectSelector && !isSubtask && (
            <div className="form-group full-width">
              <div className="modal-select-shell accent-purple">
                <select
                  name="project"
                  value={formData.project}
                  onChange={handleChange}
                >
                  <option value="">Sin proyecto</option>

                  {safeProjects
                    .filter((project) => !project.isDefault)
                    .map((project) => (
                      <option key={project._id} value={project._id}>
                        {project.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
          )}

          <div className="form-group full-width">
            <div className="modal-select-shell accent-yellow">
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                required
              >
                <option value="">Selecciona estado</option>
                <option value="Nueva">Nueva</option>
                <option value="Trabajando">Trabajando</option>
                <option value="Bloqueada">Bloqueada</option>
                <option value="Pendiente">Pendiente</option>
                <option value="Completada">Completada</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <div className="modal-select-shell accent-coral">
                <select
                  name="responsible"
                  value={formData.responsible}
                  onChange={handleChange}
                >
                  <option value="">Responsable</option>

                  {safeUsers.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <div className="modal-select-shell accent-teal">
                <select
                  name="validator"
                  value={formData.validator}
                  onChange={handleChange}
                >
                  <option value="">Validador</option>

                  {safeUsers.map((user) => (
                    <option key={user._id} value={user._id}>
                      {user.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="form-group full-width delivery-date-group">
            <label htmlFor="dueDate">Fecha de entrega</label>

            <div className="modal-date-shell accent-teal">
              <input
                id="dueDate"
                type="date"
                name="dueDate"
                className={formData.dueDate ? 'has-date-value' : ''}
                value={formData.dueDate}
                onChange={handleChange}
              />

              <span className="modal-date-placeholder">
                Día / Mes / Año
              </span>
            </div>
          </div>

          <div className="form-group full-width">
            <textarea
              name="notes"
              placeholder="Notas"
              value={formData.notes}
              onChange={handleChange}
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="modal-primary-button">
              Guardar
            </button>

            <button
              type="button"
              className="modal-secondary-button"
              onClick={onClose}
            >
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TaskForm;
